module.exports = __webpack_public_path__ + "img/1970East-031_WEB-min.2a9791d1.jpg";